<template>
    <span>{{ value }}</span>
</template>

<script>
export default {
    props: ['value'],
};
</script>



// WEBPACK FOOTER //
// SimpleText.vue?75ec6b06